import { Injectable } from '@angular/core';
import { AppConfigService } from "../../app-config.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { ApiDataSectionsResponse, IDataForFront, ISessionLoginRes } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class StartService {
  private get urlNTS(): string {
    return this.conf.backendINV;
  }

  private get OrderManagement(): string {
    return this.conf.OrderManagement;
  }

  private get uasService(): string {
    return this.conf.uasService;
  }

  private get landingPage(): string {
    return this.conf.landingPage;
  }

  private get trading(): string {
    return this.conf.trading;
  }

  constructor(
    private http: HttpClient,
    private conf: AppConfigService
  ) {
  }

  toOADate(date: any) {
    let utc18991230 = new Date("1899-12-30").getTime();
    let msPerDay = 24 * 60 * 60 * 1000;
    let offsetTime = new Date().getTimezoneOffset() * (-1); // correct value from negative to positive number
    if (date instanceof Date) {
      date = new Date(date).getTime();
    }
    let res = -utc18991230 + date + offsetTime * 60 * 1000;

    return (res / msPerDay);
  }

  checkPrivileges(str) {
    let privilegesArray = localStorage.getItem('privileges')
    return privilegesArray.includes(str)
  }

  GetPrivilegesFromRedis(SessionKey) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey);

    return SessionKey === "" ?
      this.http.get(`${this.urlNTS}${this.uasService}/RedisExchange/GetPrivilegesFromRedis`).toPromise() :
      this.http.get(`${this.urlNTS}${this.uasService}/RedisExchange/GetPrivilegesFromRedis`, { headers: myHeaders }).toPromise();
  }

  public GetSections(sessionKey: string): Observable<ApiDataSectionsResponse> {
    const myHeaders: HttpHeaders = new HttpHeaders().set('Authorization', sessionKey);
    const url: string = `${this.urlNTS}${this.OrderManagement}/Filters/GetRefbookByName?RefbookName=sections`;

    return sessionKey === ''
      ? this.http.get<ApiDataSectionsResponse>(url)
      : this.http.get<ApiDataSectionsResponse>(url,
        {
          headers: myHeaders,
        }
      );
  }

  // получение языка пользователя
  GetLanguageFromRedis(SessionKey: string) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey).set('Accept', 'application/json')
    return this.http
      .get(`${this.urlNTS}${this.uasService}/RedisExchange/GetLanguageFromRedis`, { headers: myHeaders }).toPromise()

  }

  GetHeaderInfoFromRedis(SessionKey: string) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey).set('Accept', 'application/json')
    return this.http
      .get(`${this.urlNTS}${this.uasService}/RedisExchange/GetHeaderInfoFromRedis`, { headers: myHeaders }).toPromise()

  }

  public getDataForFront(sessionKey: string): Observable<IDataForFront> {
    const myHeaders = new HttpHeaders().set('Authorization', sessionKey);

    return this.http.get<IDataForFront>(`${this.urlNTS}${this.uasService}/RedisExchange/GetDataForFront`, { headers: myHeaders });
  }

  GetFullDataFromRedis(SessionKey) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey);
    return this.http.get(`${this.urlNTS}${this.uasService}/RedisExchange/GetFullDataFromRedis`, { headers: myHeaders }).toPromise();
  }

  SetPreferredLanguage(SessionKey: string, body: any) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey);
    return this.http
      .post(`${this.urlNTS}${this.uasService}/Buce/SetPreferredLanguage`, body, { headers: myHeaders })
      .toPromise()
      .then(res => res);
  }

  public hasWorkerRole(sessionKey: string): Observable<boolean> {
    const myHeaders = new HttpHeaders().set('Authorization', sessionKey);
    return this.http
      .get<boolean>(`${this.urlNTS}${this.OrderManagement}/Auth/HasWorkerRole`, { headers: myHeaders });
  }

  public logOut(sessionKey: string): Observable<any> {
    localStorage.removeItem('privileges');
    localStorage.removeItem('createOffer')
    sessionStorage.clear();
    localStorage.removeItem('sections');
    localStorage.removeItem('autoControlChanges');
    localStorage.removeItem('viewOffer');

    const myHeaders = new HttpHeaders().set('Authorization', sessionKey);

    return this.http.post(
      `${this.urlNTS}${this.uasService}/Auth/Logout`,
      { headers: myHeaders }
    );
  }


  // получение сегодняшних сессий
  GetTodaySessionsList(SessionKey: string) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey).set('Accept', 'application/json')
    return this.http
      .get(`${this.urlNTS}${this.landingPage}/Sessions/GetTodaySessionsList`, { headers: myHeaders }).toPromise()

  }

  // получение новостей трейдер и неавт-ный
  GetNewsListNew(SessionKey: string, currentPage: number) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey).set('Accept', 'application/json')
    return this.http
      .get(`${this.urlNTS}${this.landingPage}/News/GetNewsListNew?CurrentPageNum=${currentPage}`, { headers: myHeaders }).toPromise()

  }

  // получение новостей работник
  GetNewsListNewWorker(SessionKey: string, currentPage: number, isOnlyActive: any) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey).set('Accept', 'application/json')
    return this.http
      .get(`${this.urlNTS}${this.landingPage}News/worker/BuceGetNewsListNew?CurrentPageNum=${currentPage}&IsOnlyActive=${isOnlyActive}`, { headers: myHeaders }).toPromise()

  }

  //изменить актуальность новости
  ChangeNewsActivity(SessionKey: string, body: any) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey);
    return this.http
      .post(`${this.urlNTS}${this.landingPage}News/worker/BuceChangeNewsActivity`, body, { headers: myHeaders })
      .toPromise()
      .then(res => res);
  }


  //добавить новость
  SetNews(SessionKey: string, body: any) {
    const myHeaders = new HttpHeaders().set('Authorization', SessionKey);
    return this.http
      .post(`${this.urlNTS}${this.landingPage}News/worker/BuceSetNews`, body, { headers: myHeaders })
      .toPromise()
      .then(res => res);
  }

  //вход в торги
  public sessionLogin(
    sessionKey: string,
    sectionId: number,
    sessionId: number
  ): Observable<ISessionLoginRes> {
    const myHeaders = new HttpHeaders().set('Authorization', sessionKey);
    return this.http.get<ISessionLoginRes>(
      `${this.urlNTS}${this.trading}/Sessions/SessionLogin?IdSection=${sectionId}&IdSession=${sessionId}`,
      { headers: myHeaders }
    );
  }

    // получение серверного времени
    public getServerDatetime(): Observable<number> {
      return this.http.get<number>(
        `${this.urlNTS}${this.trading}/General/GetServerDatetime`
      );
    }
}
